import React from 'react';
import IECompatibilityMessage from '../Login/IECompatibilityMessage';
import { LanguageSelector } from '../../Language/LanguageSelector';
import UserInformation from '../UserInformation/UserInformation';
import Logout from '../Logout/Logout';
import Help from '../Help/Help';

export default function Header(props) { 
    return (
        <div className={!props.isAuthenticate ?  "header header-content" :"header"} >
            <div className="nmbs-logo" title={props.appVersion}></div>
            <div className="header-links">
                <IECompatibilityMessage />
                {!props.isAuthenticate && <Help />}
                {props.isAuthenticate && <div style={{ float: 'left' }}> <UserInformation userId = {props.userId} /></div>} 
                {props.isAuthenticate && <div style={{ float: 'left' }}><Logout onLogoutClick={(x) => props.changeIsLogout(x)} /></div>}
                <LanguageSelector />
            </div>
        </div>
    )
}